import * as xlsx from 'xlsx';
import { Fields } from './components/ui/InviteUsersUI';

function isInviteUsersSheet(sheet: xlsx.WorkSheet): boolean {
	const a1 = sheet['A1'];
	const b1 = sheet['B1'];
	console.log("sheet invalid")
	if (!a1 || !b1) return false;
	return a1.v === "MIT_BEREDSKAB_TEMPLATE" && b1.v === "INVITE_USERS";
}

export default function parseInviteUsersSpreadsheet(data: ArrayBuffer): Fields[] | null {
	const workbook = xlsx.read(data, { cellDates: true });
	if (workbook.SheetNames.length < 1) {
		return null;
	}
	const firstSheetName = workbook.SheetNames[0];
	const firstSheet = workbook.Sheets[firstSheetName];
	console.log(firstSheet);
	if (!isInviteUsersSheet(firstSheet)) {
		return null;
	}
	const array = xlsx.utils.sheet_to_json(firstSheet, { header: 1 }) as unknown[][];
	const userArray = array.slice(4);

	let users: Fields[] = [];
	for (const u of userArray) {
		let fields: Fields = { email: '', givenName: '', familyName: '' };

		if (typeof u[0] === 'string') fields.email = u[0];
		if (typeof u[1] === 'string') fields.givenName = u[1];
		if (typeof u[2] === 'string') fields.familyName = u[2];
		users.push(fields);
	}

	return users;
}
